import { cn } from "@/lib/utils";

/** Static loading placeholder. No pulse: continuous animations are avoided app-wide. */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn("bg-muted rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
